import { useState } from 'react';

import CrossTicketsWorklist from './cross-worklist';
import BirthTicketsWorklist from './birth-worklist';
import SectionTabs from '../../navigation/section-tabs';
import { ANIMAL_TABS } from '../../navigation/tabs';

import './styles/worklist.css';

// ASOCEBU con dos tabs (0018 · registro de cría 0060):
//   · Tickets de cruces   → ticket por clivage (se asocia tras la T.E./dx)
//   · Tickets de preñeces → ticket de registro de la cría (se asigna tras el parto)
const TABS = [
    { key: 'crosses', label: 'Tickets de cruces' },
    { key: 'births',  label: 'Tickets de preñeces' },
];

export default function AsocebuWorklist() {
    const [tab, setTab] = useState('crosses');

    return (
        <div className="aso-page">
            <SectionTabs tabs={ANIMAL_TABS} />
            <div className="aso-tabs" role="tablist" aria-label="Tipo de ticket">
                {TABS.map((t) => (
                    <button
                        key={t.key}
                        type="button"
                        role="tab"
                        aria-selected={tab === t.key}
                        className={`aso-tab ${tab === t.key ? 'aso-tab--active' : ''}`}
                        onClick={() => setTab(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            {tab === 'crosses' ? <CrossTicketsWorklist /> : <BirthTicketsWorklist />}
        </div>
    );
}
